import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const Icon = (props) => {
  return (
    <FontAwesomeIcon {...props} icon={faMagnifyingGlass} />
  );
}

export default Icon;
